<template>
  <a-modal :open="open" @cancel="closeAction" class="modal-no-padding reference-alignment-modal" style="width: 400px">
    <div class="modal-no-padding__header">
      <h2>Совпадения с эталонным профилем</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      <a-select
          v-model:value="selectedReferenceProfileId"
          :options="referenceProfileOptions"
          placeholder="Выберите эталонный профиль"
          style="width: 100%; margin-bottom: 16px"
      />

      <div v-if="selectedUsers && selectedUsers.length" class="alignment-wrapper">
        <div
            class="alignment-item"
            v-for="user in selectedUsers"
            :key="user.user_id"
        >
          <a :href="'/staff/' + user.user_id + '/edit'" target="_blank" class="profile-name">
            {{ user.name }}
          </a>

          <div>{{ user.aligned }}%</div>
        </div>
      </div>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeAction">Закрыть</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>

import {ref, watch} from "@vue/runtime-core";
import {computed} from "@vue/reactivity";

export default {
  props: {
    open: Boolean,
    referenceProfileAlignment: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['cancel', 'close'],
  setup(props, context) {
    const closeAction = () => {
      context.emit('close');
    }

    const selectedReferenceProfileId = ref(null);

    const referenceProfileOptions = computed(() => {
      return props.referenceProfileAlignment.map(item => ({
        label: item.title,
        value: item.reference_profile_id,
      }));
    });

    const selectedUsers = computed(() => {
      const selectedProfile = props.referenceProfileAlignment.find(
          item => item.reference_profile_id === selectedReferenceProfileId.value
      );

      return selectedProfile?.users ?? [];
    });


    watch(() => referenceProfileOptions.value,
        (options) => {
          if (!selectedReferenceProfileId.value && options.length) {
            selectedReferenceProfileId.value = options[0].value;
          }
        },
        { immediate: true }
    );

    return {
      closeAction,
      selectedUsers,
      referenceProfileOptions,
      selectedReferenceProfileId,
    }
  }
}
</script>

<style scoped lang="scss">
.reference-alignment-modal {

  h2 {
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
  }
}

.reference-profile-alignment {
  text-align: start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 16px;
}

.alignment-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.alignment-item {
  display: flex;
  justify-content: space-between;
  row-gap: 8px;
  align-items: center;
}

.profile-name {
  color: var(--main-green);
}
</style>
